/**
 * Returns discount amount for the product taking into account single or multi-account product types.
 *
 * @param product
 * @return {number}
 */
export default (product) => {
    const productId = product?.product_id;
    let result = 0;
    // doBoard has accounts.
    if (productId === 7) {
        result = product?.account_discount_amount;
    } else {
        result = product?.discount_amount;
    }
    return result;
}
